import type { NotificationChannel, NotificationPrefs } from "@/lib/types";

export function isOn(
  prefs: NotificationPrefs,
  reason: string,
  channel: NotificationChannel,
): boolean {
  return Boolean(prefs.matrix[reason]?.[channel]);
}

export function withToggle(
  prefs: NotificationPrefs,
  reason: string,
  channel: NotificationChannel,
  value: boolean,
): NotificationPrefs {
  return {
    ...prefs,
    matrix: {
      ...prefs.matrix,
      [reason]: { ...(prefs.matrix[reason] ?? {}), [channel]: value },
    },
  };
}
